import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Searchbar from "../chunks/Searchbar";
import AddPixelModal from "../chunks/AddPixelModal";
import youtubeImg from "../img/youtube.png";
import Tabs from "../chunks/Tabs";
import axios from "axios";
import GoogleTabs from "../components/GoogleTabs";

import Swal from "sweetalert2";
const GoogleAdsTracking = () => {
  const [isopen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    status: false,
    ad_account: "",
    gmt_account: "",
    pixel_id: "",
  });
  const [addAdPixel, setAddAdPiexl] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://sgbnode.solcoder.com/google-adv"
      );
      console.log("dd", response.data);
      setAddAdPiexl(response.data); // Assuming response.data contains the list
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const statusChange = (e, ind) => {
    const arr = [...addAdPixel];
    arr[ind].status = e?.target?.checked;
    setAddAdPiexl(arr);
  };

  const handleDelete = async (id) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmResult.isConfirmed) {
      try {
        const response = await axios.delete(
          `https://sgbnode.solcoder.com/google-adv/${id}`
        );

        if (response.status === 200) {
          console.log("Deleted successfully:", response.data);

          // Show success message
          Swal.fire("Deleted!", "Your item has been deleted.", "success");
          setAddAdPiexl((prevAdPixels) =>
            prevAdPixels.filter((item) => item.id !== id)
          );
          // Optionally update your state to remove the deleted item from the list
        } else {
          console.error("Failed to delete:", response.status);
          Swal.fire("Error", "Failed to delete the item.", "error");
        }
      } catch (error) {
        console.error("Error while deleting:", error);
        Swal.fire("Error", "Something went wrong.", "error");
      }
    }
  };

  return (
    <div className="pixel-screen-wrapper">
      <div className="main-container">
        <Tabs />
        <Searchbar setState={setIsOpen} />

        <Link to="#" className="youtube-link">
          <img src={youtubeImg} alt="youtube-icon" />
          How To Add Google Pixel
        </Link>
        <table>
          <thead>
            <th>Status</th>
            <th>Ads Account</th>
            <th>GTM Account</th>
            <th>Pixel ID</th>
            <th>Actions</th>
          </thead>
          <tbody>
            {addAdPixel?.map((val, ind) => {
              return (
                <tr key={ind}>
                  <td>
                    <input
                      type="checkbox"
                      id={`switch-${ind}`}
                      className="checkbox"
                      checked={val?.status}
                      onChange={(e) => statusChange(e, ind)}
                    />
                    <label htmlFor={`switch-${ind}`} className="toggle"></label>
                  </td>
                  <td>
                    {val?.googleAdsName}/{val?.googleAdsID}
                  </td>
                  <td>{val?.gtmContainerName}</td>
                  <td>{val?.pixelId}</td>

                  <td>
                    <Link to="#" onClick={() => handleDelete(val?.id)}>
                      <i className="bi bi-trash3-fill"></i>
                    </Link>
                    <Link
                      to={{
                        pathname: "/google-adds-tracking-setting",
                        search: `?shop_url=${val.shopurl}`,
                      }}
                      onClick={() => {
                        // Save the row data to localStorage
                        localStorage.setItem(
                          "adPixelData",
                          JSON.stringify(val)
                        );
                      }}
                    >
                      <i className="bi bi-gear-fill"></i>
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GoogleAdsTracking;
